export default "__VITE_ASSET__DBG3BDo7__"